import { render } from "./Wheel10.vue?vue&type=template&id=2468c52c"
const script = {}
script.render = render

export default script